// React Thirty Party Library
import {
  Drawer,
  Form,
  Input,
  Tooltip,
  Select,
  Col,
  Row,
  Checkbox,
  InputNumber,
} from "antd";
import { LockOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import InputMask from "react-input-mask";

//  Constants Library
import { ROOT_CONSTANT } from "../../../../../../constants";

// Components Library
import { BtnSubmit, Options } from "../../../../../../components";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

// Styles Library
import "./index.css";

const { reduxStoreWrapper } = REDUX_UTIL;

const { bankList } = Options;
const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;
const { Option } = Select;

const DrawerFormEmployee = (props) => {
  const { isOpen, setIsOpen, type, form, handleSave } = props;
  const dispatch = useDispatch();

  const [useEmployeeNameIC, setuseEmployeeNameIC] = useState(false);

  const group = useSelector(reduxStoreWrapper("group.byID"));
  const company = useSelector(reduxStoreWrapper("company.byID"));
  const user = useSelector(reduxStoreWrapper("user"));

  useEffect(() => {
    if (isOpen) {
      dispatch(REDUX_ACTION.v1_group.get_all_group_request());
    }
  }, [isOpen, dispatch]);

  useEffect(() => {
    if (useEmployeeNameIC) {
      const employeeName = form.getFieldValue("name");
      const employeeIC = form.getFieldValue("ic");
      form.setFieldsValue({
        bank_holderName: employeeName,
        bank_holderIc: employeeIC,
      });
    } else {
      form.setFieldsValue({ bank_holderName: "", bank_holderIc: "" });
    }
  }, [useEmployeeNameIC, form]);

  const optionsGroup = group
    ? Object.values(group).map((g) => ({
        value: g.groupid,
        label: g.name,
        color: g.color,
      }))
    : [];

    const optionsCompany = company
    ? Object.values(company)
        .filter((g) => g.status === 1 || g.status === 2)
        .map((g) => ({
          value: g.coid,
          label: g.name,
        }))
    : [];
  

    const MaskedInput = (props) => (
      <InputMask
        mask="999999-99-9999"
        maskChar=""
        {...props}
        onChange={(e) => {
          // Remove non-numeric characters
          const value = e.target.value.replace(/\D/g, "");
          // Ensure it conforms to the mask
          if (value.length <= 12) {
            props.onChange(e);
          }
        }}
      >
        {(inputProps) => <Input {...inputProps} />}
      </InputMask>
    );

  // const formatInput = (value) => {
  //   if (!value) return ' ';
  //   return `${value}`.replace(/\D/g, '');
  // };

  // const parseInput = (value) => {
  //   return parseInt(value || ' ', 10);
  // };

  const formatInput = (value) => {
    return value;
  };

  const parseInput = (value) => {
      return value;
  };

  const handleKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
    }
  };
  

  const ActionButton = (
    <Form.Item style={{ paddingTop: "20px" }}>
      <div>
        <BtnSubmit
          display="inline-block"
          text={type === "add" ? "Create" : "Save"}
          bgColor="#0E2483"
          color="white"
          padding="9px 18px"
          onClick={() => {
            handleSave();
            setIsOpen(false);
          }}
        />
        {type === "add" && (
          <BtnSubmit
            display="inline-block"
            text="Create & add another"
            bgColor="#0E2483"
            color="white"
            padding="9px 15px"
            onClick={() => {
              handleSave();
              form.resetFields();
            }}
          />
        )}
        <BtnSubmit
          display="inline-block"
          text="Cancel"
          bgColor="transparent"
          color="#C8C8C8"
          padding="9px 18px"
          border="1px solid #C8C8C8"
          onClick={() => {
            setIsOpen(false);
            form.resetFields();
          }}
        />
      </div>
    </Form.Item>
  );

  return (
    <>
      <Drawer
        title={type === "add" ? "Create Employee" : "Edit Employee"}
        placement="right"
        closable={false}
        width={410}
        onClose={() => setIsOpen(false)}
        footer={ActionButton}
        open={isOpen}
        style={{
          textAlign: "center",
          fontSize: "20px",
        }}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Row>
            <Col className="subtitle">
              <span>Employee information</span>
            </Col>
            <Col style={{ width: "100%", marginBottom: "10px" }}>
              {type === "edit" && (
                <>
                  <label htmlFor="memid" className="labelInput">
                    Employee ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="memid"
                    rules={[
                      {
                        required: true,
                        message: "Employee ID is required",
                      },
                    ]}
                  >
                    <Input
                      readOnly
                      className="inputForm"
                      style={{
                        backgroundColor: "transparent",
                        color: "black !important",
                      }}
                      suffix={<LockOutlined style={{ color: "#D9D9D9" }} />}
                    />
                  </Form.Item>
                </>
              )}
            </Col>

            <Col style={{ width: "100%" }}>
              <label htmlFor="name" className="labelInput">
                Employee name <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Employee name is required",
                  },
                ]}
              >
                <Input className="inputForm" />
              </Form.Item>
            </Col>
            <Col style={{ width: "100%", marginBottom: "10px" }}>
              {user.uroleid === "A" && (
                <>
                  <label htmlFor="coName" className="optionLabel">
                    Company Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Form.Item
                    name="coid"
                    rules={[
                      {
                        required: true,
                        message: "Employee company is required",
                      },
                    ]}
                  >
                    <Select
                      suffixIcon={
                        type === "add" ? (
                          <span style={{ color: "#0E2483", fontSize: "16px" }}>
                            Select
                          </span>
                        ) : (
                          <LockOutlined style={{ color: "#D9D9D9" }} />
                        )
                      }
                      style={{
                        position: "relative",
                        marginTop: "11px",
                        marginLeft: "5px",
                        borderRadius: "var(--br-3xs)",
                        height: "40px",
                        width: "100%",
                        textAlign: "left",
                      }}
                      disabled={type === "edit"}
                    >
                      {optionsCompany.map((option) => (
                        <Option
                          key={option.value}
                          value={option.value}
                          style={{
                            color: "black",
                          }}
                        >
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              )}
            </Col>

            <Col style={{ width: "100%", marginBottom: "10px" }}>
              <label htmlFor="position" className="labelInput">
                Job Position <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="position"
                rules={[
                  {
                    required: true,
                    message: "Job position is required",
                  },
                ]}
              >
                <Input className="inputForm" />
              </Form.Item>
            </Col>

            <Col style={{ width: "100%", marginBottom: "10px" }}>
              <label htmlFor="ic" className="labelInput">
                IC Number <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="ic"
                rules={[
                  {
                    required: true,
                    message: "IC Number is required",
                  },
                ]}
              >
                <MaskedInput
                  className="inputForm"
                  style={{ backgroundColor: "transparent" }}
                  placeholder="xxxxxx-xx-xxxx"
                  readOnly={type === "edit" && user.uroleid === "EMR"}
                  suffix={
                    type === "edit" && user.uroleid === "EMR" ? (
                      <LockOutlined style={{ color: "#D9D9D9" }} />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>

            <Col style={{ width: "100%", marginBottom: "10px" }}>
              <Row>
                <Col span={8}>
                  <label htmlFor="contact" className="labelInput">
                    Contact <span style={{ color: "red" }}>*</span>
                  </label>
                  <div
                    className="inputForm"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "90%",
                      marginRight: "8px",
                      height: "42px",
                    }}
                  >
                    <img
                      src={icon_malaysia}
                      alt="country"
                      style={{ marginTop: "3px" }}
                    />
                    <span style={{ marginLeft: "7px", marginTop: "3px" }}>
                      +60
                    </span>
                  </div>
                </Col>
                <Col span={16}>
                  <Form.Item
                    name="contact"
                    rules={[
                      {
                        required: true,
                        message: "Contact is required",
                      },
                    ]}
                  >
                    <InputNumber
                      className="inputForm inputNumber"
                      maxLength="10"
                      readOnly={type === "edit"}
                      style={{ backgroundColor: "transparent" }}
                      suffix={
                        type === "edit" && (
                          <LockOutlined style={{ color: "#D9D9D9" }} />
                        )
                      }
                      controls={false}
                      inputMode="numeric"
                      step={null}
                      formatter={formatInput}
                      parser={parseInput} 
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col style={{ width: "100%", marginBottom: "20px" }}>
              <label htmlFor="empRefID" className="labelInput">
                Employee reference ID
              </label>
              <Form.Item
                name="empRefID"
              >
                <Input className="inputForm" />
              </Form.Item>
            </Col>

            <Col className="subtitle" style={{ marginTop: "-10px" }}>
              <span>Payroll Advance Request Information</span>
            </Col>

            <Col style={{ width: "100%", margin: "10px 0px" }}>
              <label htmlFor="baseSal" className="labelInput">
                Base Salary
                <Tooltip title="Base salary is the employee's pay before any overtime or allowances are added.">
                  <InfoCircleOutlined
                    style={{
                      color: "rgba(0,0,0,.45)",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </label>
              <Form.Item name="baseSal">
                <InputNumber
                  className="inputForm inputNumber"
                  prefix={
                    <span style={{ marginLeft: "5px", marginRight: "7px" }}>
                      RM
                    </span>
                  }
                  controls={false}
                  inputMode="numeric"
                  step={null}
                  formatter={formatInput}
                  parser={parseInput} 
                  onKeyPress={handleKeyPress}
                />
              </Form.Item>
            </Col>

            <Col style={{ width: "100%", marginBottom: "20px" }}>
              <label htmlFor="eligAmount" className="labelInput">
                Eligible amount <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="eligAmount"
                rules={[
                  {
                    required: true,
                    message: "Eligible amount is required",
                  },
                  {
                    validator: (_, value) => {
                      if (value > 1500) {
                        return Promise.reject(
                          new Error(
                            "Eligible amount must be less than or equal to 1500"
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  className="inputForm inputNumber"
                  prefix={
                    <span style={{ marginLeft: "5px", marginRight: "7px" }}>
                      RM
                    </span>
                  }
                  placeholder="Maximum MYR 1,500"
                  controls={false}
                  inputMode="numeric"
                  step={null}
                  formatter={formatInput}
                  parser={parseInput} 
                  onKeyPress={handleKeyPress}
                />
              </Form.Item>
            </Col>

            <Col className="subtitle">
              <span>Bank information</span>
            </Col>

            <Col style={{ width: "100%", margin: "10px 0px" }}>
              <label htmlFor="bank_name" className="optionLabel">
                Bank name <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="bank_name"
                rules={[
                  {
                    required: true,
                    message: "Bank name is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  suffixIcon={
                    <span style={{ color: "#0E2483", fontSize: "16px" }}>
                      Select
                    </span>
                  }
                  style={{
                    position: "relative",
                    marginTop: "11px",
                    marginLeft: "5px",
                    borderRadius: "var(--br-3xs)",
                    height: "40px",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  {bankList.map((option) => (
                    <Option
                      key={option.value.name} 
                      value={option.value.name}
                    >
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col style={{ width: "100%" }}>
              <label htmlFor="bank_acc" className="labelInput">
                Bank account <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="bank_acc"
                rules={[
                  {
                    required: true,
                    message: "Bank account is required",
                  },
                ]}
              >
                <InputNumber
                  className="inputForm inputNumber"  
                  controls={false}
                  inputMode="numeric"
                  step={null}
                  formatter={formatInput}
                  parser={parseInput} 
                  onKeyPress={handleKeyPress}
                />
              </Form.Item>
            </Col>

            <Col className="checkbox">
              <Checkbox
                checked={useEmployeeNameIC}
                onChange={(e) => setuseEmployeeNameIC(e.target.checked)}
              >
                Same as employee name & IC
              </Checkbox>
            </Col>

            <Col style={{ width: "100%", marginTop: "20px" }}>
              <label htmlFor="bank_holderName" className="labelInput">
                Bank holder name <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="bank_holderName"
                rules={[
                  {
                    required: true,
                    message: "Bank holder name is required",
                  },
                ]}
              >
                <Input className="inputForm" readOnly={useEmployeeNameIC} />
              </Form.Item>
            </Col>

            <Col style={{ width: "100%", marginTop: "10px" }}>
              <label htmlFor="bank_holderIc" className="labelInput">
                Bank holder IC <span style={{ color: "red" }}>*</span>
              </label>
              <Form.Item
                name="bank_holderIc"
                rules={[
                  {
                    required: true,
                    message: "Bank holder IC is required",
                  },
                ]}
              >
                <MaskedInput
                  className="inputForm"
                  style={{ backgroundColor: "transparent" }}
                  placeholder="xxxxxx-xx-xxxx"
                  readOnly={
                    useEmployeeNameIC &&
                    type === "edit" &&
                    user.uroleid === "EMR"
                  }
                  suffix={
                    type === "edit" && user.uroleid === "EMR" ? (
                      <LockOutlined style={{ color: "#D9D9D9" }} />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default DrawerFormEmployee;
